import { AlertCircle, CheckCircle, Clock } from 'lucide-react';
import type { ElementType } from 'react';
import type { BookingStatus } from '@/types/booking.types';

export type ReservationDrawerStatusKey =
  | 'confirmed'
  | 'pending'
  | 'checkedin'
  | 'checkedout'
  | 'cancelled';

export const RESERVATION_STATUS_MAP: Record<BookingStatus, ReservationDrawerStatusKey> = {
  CONFIRMED: 'confirmed',
  PENDING: 'pending',
  CHECKED_IN: 'checkedin',
  CHECKED_OUT: 'checkedout',
  CANCELLED: 'cancelled',
  NO_SHOW: 'cancelled',
};

export const reservationStatusConfig: Record<
  ReservationDrawerStatusKey,
  { label: string; color: string; icon: ElementType }
> = {
  confirmed: {
    label: 'Confirmada',
    color: 'bg-emerald-500/20 text-emerald-400 border-emerald-500/30',
    icon: CheckCircle,
  },
  pending: {
    label: 'Pendente',
    color: 'bg-amber-500/20 text-amber-400 border-amber-500/30',
    icon: Clock,
  },
  checkedin: {
    label: 'Hospedado',
    color: 'bg-blue-500/20 text-blue-400 border-blue-500/30',
    icon: CheckCircle,
  },
  checkedout: {
    label: 'Check-out',
    color: 'bg-muted/40 text-muted-foreground border-border/60',
    icon: CheckCircle,
  },
  cancelled: {
    label: 'Cancelada',
    color: 'bg-red-500/20 text-red-400 border-red-500/30',
    icon: AlertCircle,
  },
};
